/**
 * Copyright 2026 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * THIS FILE IS AUTOGENERATED by cddlconv 0.2.0.
 * Run `tools/update_bidi_types.py` to regenerate.
 * @see https://github.com/w3c/webdriver-bidi/blob/master/index.bs
 */

import * as z from 'zod';
import {EmptyResultSchema} from './webdriver-bidi.js';

export namespace DigitalCredentials {
  export const VirtualWalletActionSchema: z.ZodLazy<
    z.ZodEnum<{
      decline: 'decline';
      respond: 'respond';
      wait: 'wait';
      clear: 'clear';
    }>
  > = z.lazy(() => z.enum(['decline', 'respond', 'wait', 'clear']));
}
export namespace DigitalCredentials {
  export const SetVirtualWalletBehaviorParametersSchema: z.ZodLazy<
    z.ZodObject<{
      action: typeof DigitalCredentials.VirtualWalletActionSchema;
      context: z.ZodOptional<z.ZodString>;
      protocol: z.ZodOptional<z.ZodString>;
      response: z.ZodOptional<z.ZodRecord<z.ZodString, z.ZodAny>>;
    }>
  > = z.lazy(() =>
    z.object({
      action: DigitalCredentials.VirtualWalletActionSchema,
      context: z.string().optional(),
      protocol: z.string().optional(),
      response: z.record(z.string(), z.any()).optional(),
    }),
  );
}
export namespace DigitalCredentials {
  export const SetVirtualWalletBehaviorSchema: z.ZodLazy<
    z.ZodObject<{
      method: z.ZodLiteral<'digitalCredentials.setVirtualWalletBehavior'>;
      params: typeof DigitalCredentials.SetVirtualWalletBehaviorParametersSchema;
    }>
  > = z.lazy(() =>
    z.object({
      method: z.literal('digitalCredentials.setVirtualWalletBehavior'),
      params: DigitalCredentials.SetVirtualWalletBehaviorParametersSchema,
    }),
  );
}
export namespace DigitalCredentials {
  export const SetVirtualWalletBehaviorResultSchema: z.ZodLazy<
    typeof EmptyResultSchema
  > = z.lazy(() => EmptyResultSchema);
}
